import * as moment from 'moment';
import Drawer from 'rc-drawer';
import ReactHtmlParser from 'react-html-parser';
import { useEffect, useState } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import useNetworkEmailLogDetail from '@nkr/store/network-email-log/hooks/use-network-email-log-detail';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { styles } from './styles';

interface IProps {
    id: number | null;
    centerId?: number;
    onClose: () => void;
}

const NetworkEmailDetailDrawer = ({ id, centerId, onClose }: IProps) => {
    const { app } = useAppHookContext();
    const { data, loading, error } = useNetworkEmailLogDetail(id, centerId);
    const [showRecipients, setShowRecipients] = useState<boolean>(false);
    const canViewRecipients = app.user.group.isSuper && !centerId;

    useEffect(() => {
        setShowRecipients(false);
    }, [id]);

    return (
        <Drawer width='40vw' placement='right' open={id !== null} className='network-email-view'>
            <div style={styles.drawerBody}>
                <div style={styles.drawerHeader}>
                    <h3>Network Email Details</h3>
                    <Button onClick={onClose}><Glyphicon glyph='remove' /></Button>
                </div>

                {loading && <div>Loading...</div>}
                {error && <div className='text-danger'>{error}</div>}

                {data && (
                    <div>
                        <p style={styles.drawerSummary}><strong>Sent:</strong> {data.sentDate ? `${moment(data.sentDate).format('MM/DD/YYYY HH:mm')} ET` : '-'}</p>
                        <p style={styles.drawerSummary}><strong>Sender:</strong> {data.sender}</p>
                        <p style={styles.drawerSummary}><strong>Subject:</strong> {data.subject}</p>
                        {canViewRecipients && (showRecipients ? (
                            <>
                                <p><strong>Centers:</strong> {data.centerNames?.length ? data.centerNames.join(', ') : '-'}</p>
                                <p><strong>Couriers:</strong> {data.courierNames?.length ? data.courierNames.join(', ') : '-'}</p>
                                <p><strong>Positions:</strong> {data.positionNames?.length ? data.positionNames.join(', ') : '-'}</p>
                                <p><strong>Additional Recipients:</strong> {data.additionalRecipients?.length ? data.additionalRecipients.join(', ') : '-'}</p>
                                <Button bsSize='small' onClick={() => setShowRecipients(false)}>Hide Recipients</Button>
                            </>
                        ) : (
                            <Button bsStyle='link' style={styles.recipientsLink} onClick={() => setShowRecipients(true)}>Click here to see a list of the recipients</Button>
                        ))}
                        <hr />
                        <div>{ReactHtmlParser(data.message)}</div>
                    </div>
                )}
            </div>
        </Drawer>
    );
};

export default NetworkEmailDetailDrawer;
